import React, { useState } from "react"
import PropTypes from "prop-types"
import { Modal, ModalBody, ModalHeader } from "reactstrap"
import { Column } from "react-virtualized"
import DataTable from "@swipesense/data-table"
import { basicSort } from "../../utils/sort"
import Loading from "../Loading"
import PageBanner from "../PageBanner"
import "./ExcludedLocationsModal.scss"

const ExcludedLocationsModal = (props) => {
  const [modal, setModal] = useState(props.modalOpen)

  const closeButton = (
    <button
      className="close-button fa fa-times"
      type="button"
      title="button"
      onClick={() => setModal(!modal)}
    />
  )

  return (
    <div className="ExcludedLocationsModal">
      <button
        onClick={() => {
          props.onLoad()
          setModal(!modal)
        }}
        className="excluded-areas"
      >
        View excluded areas.
      </button>
      <Modal
        isOpen={modal}
        size={"lg"}
        centered={true}
        className={"excluded-locations-modal"}
      >
        <ModalHeader close={closeButton} />
        <ModalBody>
          <PageBanner>
            <h1>Excluded Areas</h1>
          </PageBanner>
          <div className="excluded-rooms-wrapper">
            <div className="description">
              A room may excluded from contact tracing due to the size of the
              room or outlet availability.
            </div>
            <DataTable
              data={props.excludedLocations.sort(basicSort("unitName", "ASC"))}
              rowHeight={46}
              loading={props.loading}
              loadingComponent={<Loading />}
              noRowsMessage="No rooms are currently excluded from Contact Tracing."
            >
              <Column
                dataKey="unitName"
                disableSort={true}
                width={20}
                label="Unit"
              />
              <Column
                dataKey="excludedLocations"
                disableSort={true}
                width={80}
                label="Rooms"
                cellRenderer={({ cellData }) => cellData.sort().join(", ")}
              />
            </DataTable>
          </div>
        </ModalBody>
      </Modal>
    </div>
  )
}

ExcludedLocationsModal.propTypes = {
  facilityId: PropTypes.string,
  onLoad: PropTypes.func,
  loading: PropTypes.bool,
  modalOpen: PropTypes.bool,
  excludedLocations: PropTypes.arrayOf(
    PropTypes.shape({
      unitName: PropTypes.string,
      excludedLocations: PropTypes.arrayOf(PropTypes.string),
    })
  ),
}

ExcludedLocationsModal.defaultProps = {
  modalOpen: false,
  excludedLocations: [],
}

export default ExcludedLocationsModal
